<template>
  <el-dialog
    title="待填报查验信息"
    :visible.sync="innerVisible"
    width="900px"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    class="overdue-inspection-dialog"
  >
    <div class="overdue-tip">
      <i class="el-icon-warning"></i>
      <span>
        您有 <b>{{ list.length }}</b> 个订单接单已超过 <b>{{ overdueHoursLimit }}</b> 小时仍未完成查验信息填报，
        填报完成前无法使用其他功能，请点击列表中的「去填报」逐单完成填报。
      </span>
    </div>

    <div class="overdue-search">
      <el-input
        v-model="keyword"
        placeholder="搜索订单号 / 采购单位 / 商品名称"
        prefix-icon="el-icon-search"
        clearable
        size="small"
        style="width: 320px"
      />
    </div>

    <el-table :data="filteredList" border stripe size="small" max-height="360">
      <el-table-column type="index" label="序号" width="55" align="center"></el-table-column>
      <el-table-column prop="orderNo" label="订单号" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="unitName" label="采购单位" min-width="140" show-overflow-tooltip>
        <template #default="{ row }">{{ row.unitName || '—' }}</template>
      </el-table-column>
      <el-table-column label="接单时间" width="150" align="center">
        <template #default="{ row }">{{ formatTime(row.acceptedAt) }}</template>
      </el-table-column>
      <el-table-column label="逾期时长" width="100" align="center">
        <template #default="{ row }">
          <span class="overdue-hours">{{ row.overdueHours || 0 }} 小时</span>
        </template>
      </el-table-column>
      <el-table-column prop="pendingItemCount" label="待填报商品数" width="110" align="center"></el-table-column>
      <el-table-column prop="productNames" label="涉及商品" min-width="160" show-overflow-tooltip>
        <template #default="{ row }">{{ row.productNames || '—' }}</template>
      </el-table-column>
      <el-table-column label="操作" width="90" align="center" fixed="right">
        <template #default="{ row }">
          <el-button type="text" size="mini" @click="handleGoFill(row)">去填报</el-button>
        </template>
      </el-table-column>
      <template #empty>
        <span class="empty-text">没有匹配的订单</span>
      </template>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'OverdueInspectionDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    list: {
      type: Array,
      default: () => []
    },
    overdueHoursLimit: {
      type: Number,
      default: 72
    }
  },
  data() {
    return {
      keyword: ''
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    filteredList() {
      const kw = (this.keyword || '').trim().toLowerCase()
      if (!kw) return this.list
      return this.list.filter(item => {
        return (
          (item.orderNo || '').toLowerCase().includes(kw) ||
          (item.unitName || '').toLowerCase().includes(kw) ||
          (item.productNames || '').toLowerCase().includes(kw)
        )
      })
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // 每次打开重置搜索词
        this.keyword = ''
      }
    }
  },
  methods: {
    formatTime(val) {
      if (!val) return '—'
      return String(val).replace('T', ' ').substring(0, 19)
    },
    handleClose() {
      // 强制填报模式：不允许直接关闭，只能通过「去填报」离开弹窗
      this.$message.warning('请先填报查验信息')
    },
    handleGoFill(row) {
      this.innerVisible = false
      // 跳转到「我的订单」并按订单号定位，由订单列表页自动打开该订单的查验填报弹窗
      this.$router.push({
        path: '/order/supplier',
        query: { inspectionOrderId: row.orderId, t: Date.now() }
      })
    }
  }
}
</script>

<style scoped>
.overdue-tip {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 14px;
  margin-bottom: 14px;
  background: #fef0f0;
  border: 1px solid #fde2e2;
  border-radius: 4px;
  color: #606266;
  line-height: 1.7;
  font-size: 14px;
}
.overdue-tip .el-icon-warning {
  color: #e6a23c;
  font-size: 18px;
  margin-top: 2px;
}
.overdue-tip b {
  color: #f56c6c;
  padding: 0 2px;
}
.overdue-search {
  margin-bottom: 12px;
}
.overdue-hours {
  color: #f56c6c;
  font-weight: 600;
}
.dialog-footer {
  text-align: right;
}
.empty-text {
  color: #909399;
  font-size: 13px;
}
</style>
